import { create } from 'zustand';

interface AuthDataActions {
  getRetailerId: () => string;
  getDszEmail: () => string;
}

type AuthDataStore = AuthDataActions;

const useAuthDataStore = create<AuthDataStore>((set, get) => ({
  getRetailerId: () => {
    try {
      return localStorage.getItem('customer_id') || '';
    } catch (error) {
      console.error('Error reading retailerId from localStorage:', error);
      return '';
    }
  },

  getDszEmail: () => {
    try {
      return localStorage.getItem('dsz_email') || '';
    } catch (error) {
      console.error('Error reading dszEmail from localStorage:', error);
      return '';
    }
  }
}));

export default useAuthDataStore;
